export const AUTH = {
  loginEmail: "auth-login-email",
  loginPassword: "auth-login-password",
  loginSubmit: "auth-login-submit",
  loginError: "auth-login-error",
  logoutBtn: "auth-logout-btn",
  languageToggle: "auth-language-toggle",
  themeToggle: "auth-theme-toggle",
};

export const NAV = {
  sidebar: "nav-sidebar",
  linkDashboard: "nav-link-dashboard",
  linkProperties: "nav-link-properties",
  linkTransactions: "nav-link-transactions",
  linkAlerts: "nav-link-alerts",
  linkReports: "nav-link-reports",
  linkUsers: "nav-link-users",
  linkAudit: "nav-link-audit",
  mobileToggle: "nav-mobile-toggle",
};

export const DASHBOARD = {
  kpiIncome: "dashboard-kpi-income",
  kpiExpense: "dashboard-kpi-expense",
  kpiNet: "dashboard-kpi-net",
  kpiOccupancy: "dashboard-kpi-occupancy",
  chartMonthly: "dashboard-chart-monthly",
  chartCategories: "dashboard-chart-categories",
  chartCountry: "dashboard-chart-country",
  propertyRanking: "dashboard-property-ranking",
};

export const PROPERTIES = {
  grid: "properties-grid",
  card: "property-card",
  addBtn: "properties-add-btn",
  dialog: "properties-dialog",
  detailTabs: "property-detail-tabs",
  editBtn: "property-edit-btn",
  deleteBtn: "property-delete-btn",
};

export const TRANSACTIONS = {
  addBtn: "transactions-add-btn",
  dialog: "transactions-dialog",
  table: "transactions-table",
  filterKind: "transactions-filter-kind",
  filterCountry: "transactions-filter-country",
  filterProperty: "transactions-filter-property",
};

export const ALERTS = {
  list: "alerts-list",
  addBtn: "alerts-add-btn",
  dialog: "alerts-dialog",
  resolveBtn: "alerts-resolve-btn",
  testEmailBtn: "alerts-test-email-btn",
};

export const REPORTS = {
  exportExcel: "reports-export-excel",
  exportPdf: "reports-export-pdf",
  filterProperty: "reports-filter-property",
  filterCountry: "reports-filter-country",
  filterStart: "reports-filter-start",
  filterEnd: "reports-filter-end",
};

export const USERS = {
  list: "users-list",
  addBtn: "users-add-btn",
  dialog: "users-dialog",
};

export const TENANTS = {
  list: "tenants-list",
  addBtn: "tenants-add-btn",
  dialog: "tenants-dialog",
  contractDialog: "tenants-contract-dialog",
  addContractBtn: "tenants-add-contract-btn",
  paymentRegisterBtn: "payment-register-btn",
};

export const MAINTENANCE = {
  list: "maintenance-list",
  addBtn: "maintenance-add-btn",
  dialog: "maintenance-dialog",
  photoUpload: "maintenance-photo-upload",
};

export const PROVIDERS = {
  list: "providers-list",
  addBtn: "providers-add-btn",
  dialog: "providers-dialog",
};

export const TIMELINE = {
  list: "timeline-list",
};

export const DROPBOX = {
  statusCard: "dropbox-status-card",
  backupBtn: "dropbox-backup-btn",
};
